module.exports = __webpack_public_path__ + "static/media/LegoJungleBattleAreaINTA0015_design_clean_v001.91f94541.png";